import { FlexProps } from "@chakra-ui/react";

import { themeStore } from "@/stores/theme";

export function getSubEditorTitleProps(): FlexProps {
  const { separatorColor } = themeStore.styles;
  return { pt: "16px", borderTop: "1px", borderColor: separatorColor };
}
